import React, { useEffect, useState } from "react";
import gameChoiceReaction from "../config/gameChoiceReaction";
import gameStroop from "../config/gameStroop";
import {
  FORWARD as gameDigitalSpanForward,
  BACKWARD as gameDigitalSpanBackward,
} from "../config/gameDigitalSpan";
import gameMentalRotation from "../config/gameMentalRotation";
import gameWisconsinCardSorting from "../config/gameWisconsinCardSorting";
import "./result.css";
import Button from "../components/Button";
import styles from "./Result.module.css";
import TableResult from "../components/TableResult";
import Share from "../components/Share";
import { getResult, pushFinishAllApi } from "../api";
import { useData } from "../contexts/DataContext";
import Waiting from "../components/Waiting";

const config = {
  1: gameChoiceReaction,
  2: gameStroop,
  3: gameDigitalSpanBackward,
  4: gameMentalRotation,
  5: gameWisconsinCardSorting,
};

const Result = (props) => {
  const { id, allresult } = useData();
  const { updateResult } = useData();
  const [loading, setLoad] = useState(true);

  useEffect(() => {
    if (props.shareId) {
      setLoad(true);
      getResult(props.shareId)
        .then((res) => {
          updateResult(res.result);
        })
        .finally(() => {
          setLoad(false);
          props.navigateNextPage();
        });
    } else {
      setLoad(true);
      if (id && props.finishGame) {
        pushFinishAllApi(id, allresult)
          .then((res) => {
            updateResult(res.result.result);
          })
          .finally(() => {
            setLoad(false);
            props.navigateNextPage();
          });
      }
    }
  }, [props.shareId,props.finishGame]);

  return (
    <div className={styles.body}>
      {loading && (
        <div>
          <div className={styles.headtext}>กำลังประมวลผล</div>
          <Waiting />
        </div>
      )}
    </div>
  );
};

export default Result;
